import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-bulk-move-to-registration',
  imports: [SharedModule],
  templateUrl: './bulk-move-to-registration.component.html',
  styleUrl: './bulk-move-to-registration.component.scss'
})
export class BulkMoveToRegistrationComponent {
  @Output() closeDialog = new EventEmitter();
  @Input() selectedProducts: any[] = [];
  @Output() reload = new EventEmitter<any>();

  isLoading = false;

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  constructor(
    private api: LeadService,
    private localStorage: LocalStorageService
  ) { }

  handleMove() {


    const payload = {
      organization_id: this.localStorage.getOrganizationId(),
      lead_id: this.selectedProducts.map(product => product.lead_id),
      current_stage: 'registration',
      reg_data: {},
      old_lead_data: {},
      user_id: this.localStorage.getUserId(),
      campus_id: this.localStorage.getCampusId(),
    }

    this.isLoading = true;

    this.api.updateBulkLead(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.closeDialog.emit();
      },
      error: (error) => {
        this.isLoading = false;
      }
    }
    );
  }
}
